
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Product from './pages/Product';
import ScrollToTop from './scrolltotop';

function App() {
  return (
     <>
      <ScrollToTop />
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/products" element={<Product />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
